
import React, { Component, Fragment } from 'react';
import { ArcaClientImageServer } from '../../../code/ArcaClientImageServer';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';


export class PhotoPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imageExists: false,
            imageHash: Date.now(),
            width: this.props.width ?? '100vw',
            isLoading: true
        };
    }

    async componentDidMount() {

        ArcaClientImageServer.GetImage(
            this.props.folder,
            this.props.id,
            ((list) => this.setState({ imageExists: true, isLoading: false })),
            (() => this.setState({ imageExists: false, isLoading: false  })),
            ((msg) => alert(msg))
        )
    }

    render() {

        let { imageExists, imageHash, isLoading } = this.state;
        let { id, folder } = this.props;

        ArcaHttpSystem.IsLogging = false;
        ArcaHttpSystem.Log(`ImageExists=${imageExists}`)

        return (

            <Fragment>
                {imageExists
                    ? <Fragment>
                        {isLoading
                            ? 'Is Loading ...'
                            : <img
                                className='centeredImage imageBorder fullWidth'
                                src={`${ArcaHttpSystem.PhotoFolder}${folder}/${id}?${imageHash}`} />
                        }
                    </Fragment>
                    : null}

            </Fragment>
        );
    }
}